import {
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react'

import { INVESTMENT_ADVISORY_AGREEMENT_URL } from 'constants/general.constants'
import PDSBox from 'designSystem/components/PDSBox/PDSBox'
import PDSButton from 'designSystem/components/PDSButton/PDSButton'
import PDSFlexBox from 'designSystem/components/PDSFlexBox/PDSFlexBox'
import PDSHeader from 'designSystem/components/PDSHeader/PDSHeader'
import PDSLink from 'designSystem/components/PDSLink/PDSLink'
import PDSSeparator from 'designSystem/components/PDSSeparator/PDSSeparator'
import PDSText from 'designSystem/components/PDSText/PDSText'
import { SIZE } from 'designSystem/foundations/constants/size'

type Props = {
  isAutomationOn: boolean | null
  onClose: () => void
  onConfirm: () => void
  showModal: boolean
}

export default function PortfolioAutomationConfirmModal({
  showModal,
  isAutomationOn,
  onClose,
  onConfirm,
}: Props) {
  const title = isAutomationOn ? 'Turn off automation?' : 'Turn on automation?'
  const buttonConfirmText = isAutomationOn ? 'Continue' : 'Turn on automation'

  return (
    <Modal isCentered isOpen={showModal} onClose={onClose} size="md">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader
          paddingBottom={SIZE.s12}
          paddingLeft={SIZE.s32}
          paddingRight={SIZE.s32}
          paddingTop={SIZE.s32}
        >
          <PDSHeader variant="h4">{title}</PDSHeader>
        </ModalHeader>
        <ModalBody
          paddingBottom={SIZE.s32}
          paddingLeft={SIZE.s32}
          paddingRight={SIZE.s32}
        >
          <PDSBox display="grid" gap={SIZE.s20}>
            {isAutomationOn ? (
              <>
                <PDSText size="md">
                  By turning off automation you are terminating the
                  discretionary investment advisory relationship with Pave
                  Investment Advisors, LLC.
                </PDSText>
                <PDSText size="md">
                  Once you have terminated your discretionary relationship with
                  Pave Investments Advisors, LLC, Pave Investment Advisors, LLC
                  makes non-discretionary recommendations to you as a
                  professional adviser, family office professional,
                  high-net-worth individual, or other type of professional
                  investor that has the investment acumen to assess and act on
                  the non-discretionary recommendations.
                </PDSText>
                <PDSText size="md">
                  Depending on how you choose to execute trades using the
                  software, you may maintain your relationship as a customer
                  with Pave Securities, LLC. As the customer, you will maintain
                  the sole discretion to approve or not approve trades in this
                  account.
                </PDSText>
              </>
            ) : (
              <>
                <PDSText size="md">
                  By turning on automation, you are hiring Pave Investment
                  Advisors, LLC as the discretionary investment adviser for this
                  account.{' '}
                  <PDSLink
                    rel="noopener noreferrer"
                    target="_blank"
                    text="Click here"
                    to={INVESTMENT_ADVISORY_AGREEMENT_URL}
                  />{' '}
                  to review your Investment Advisory Agreement with Pave
                  Investment Advisors, LLC.
                </PDSText>
                <PDSText size="md">
                  Additionally, when turning on automation, you agree to receive
                  the Investment Advisory Agreement, Form ADV Part 2A, Form CRS,
                  as well as other relevant information about the adviser and
                  your relationship as a client of the adviser.
                </PDSText>
                <PDSText size="md">
                  By pressing confirm, you agree to having reviewed and approved
                  the Investment Advisory Agreement with Pave Investment
                  Advisors, LLC.
                </PDSText>
              </>
            )}
          </PDSBox>
        </ModalBody>

        <PDSSeparator />
        <ModalFooter padding={`${SIZE.s24} ${SIZE.s40}`}>
          <PDSFlexBox flexDirection="column" gap={SIZE.s16} width="100%">
            <PDSButton
              onClick={onConfirm}
              size="md-f"
              text={buttonConfirmText}
              testId="automation-modal-confirm"
              variant="primary"
            />
            <PDSButton
              onClick={onClose}
              size="md-f"
              testId="automation-modal-cancel"
              text="Cancel"
              variant="tertiary"
            />
          </PDSFlexBox>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
